// extracted by mini-css-extract-plugin
export default {"providerLogo":"ExternalIntegrationInfo_providerLogo__yq3fD","container":"ExternalIntegrationInfo_container__oFUIr","buttonHover":"ExternalIntegrationInfo_buttonHover__Yi2vD"};